






















































import { defineComponent, ref, useContext } from '@nuxtjs/composition-api'
import isEmpty from 'lodash/fp/isEmpty'
import { usePDPNavigationObserver } from '~/composables/pdp/usePDPNavigationObserver'
import { usePdpStore } from '@/store/pdp'
import { COMPONENTS_IN_NAVIGATION } from '@/common/utils/product/constants'
export default defineComponent({
  props: {
    dilutions: {
      type: Array as () => Array<{
        application: string
        dilution: string
      }>,
      required: false,
      default: undefined,
    },
    directionsForUse: {
      type: String as () => string,
      required: false,
      default: undefined,
    },
    solutionsReagents: {
      type: String as () => string,
      required: false,
      default: undefined,
    },
    formulation: {
      type: String as () => string,
      required: false,
      default: undefined,
    },
    productStorage: {
      type: String as () => string,
      required: false,
      default: undefined,
    },
    eclipMessage: {
      type: String,
      required: false,
      default: undefined,
    },
  },
  setup(props) {
    const pdpStore = usePdpStore()
    const usageInformationRef = usePDPNavigationObserver(() => {
      pdpStore.setActiveComponentInNavigation(COMPONENTS_IN_NAVIGATION.PRODUCT_USAGE.ANCHOR)
    })
    const ctx = useContext()
    const isPreviewServer = ctx.$config.cst.isPreview

    const displayCondition = ref(
      !isEmpty(props.dilutions) ||
        !!props.productStorage ||
        !!props.directionsForUse ||
        !!props.formulation ||
        !!props.solutionsReagents
    )
    if (displayCondition.value) {
      pdpStore.setComponentAsRendered(COMPONENTS_IN_NAVIGATION.PRODUCT_USAGE)
    }

    return {
      displayCondition,
      usageInformationRef,
      isEmpty,
      isPreviewServer,
    }
  },
})
